import { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as api from "@/lib/api";

const ServicesContext = createContext({ services: [], loading: true });

export const ServicesProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .getServices()
      .then(setServices)
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => ({ services, loading }), [services, loading]);

  return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>;
};

export const useServices = () => useContext(ServicesContext);
